module.exports = __webpack_public_path__ + "img/bg.bfb07554.png";